<template>
  <div class="gameSelect">
    <div v-show="!showRecord">
      <div class="tc mb-4">
        <h3>自开彩开奖设定</h3>
      </div>
      <div
        v-for="(item, index) in filterData"
        :key="index"
        valign="top"
        style="border: solid 1px #5e5a61"
      >
        <SelectedTable ref="selectedTable" :data="item" />
      </div>
      <div class="tc mt-4" style="margin-bottom: 150px">
        <Button type="primary" @click="goSetting">选择彩种</Button>
      </div>
      <NumSettedTable ref="numSetted">
        <template v-slot:recordBtn>
          <Button
            class="tc act-record"
            type="primary"
            style="width: 100px; float: right"
            @click="showRecord = true"
            >操作纪录</Button
          >
        </template>
      </NumSettedTable>
    </div>
    <ActionRecord v-if="showRecord" @close-record="showRecord = !showRecord" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import siteGroup from 'utils/site-group.js'
import GameGroupMethods from 'utils/game-group-methods.js'
import common from '@/views/game-lobby/mixins/common.js'

const gameGroupMethods = new GameGroupMethods()

const groupData = Object.keys(gameGroupMethods.catenaIdItems).reduce((acc, val) => { // 組合所有遊戲系列的資料。
  const item = gameGroupMethods.catenaGroup(val)
  const id = String(val)
  acc[id] = {
    title: `${item}系列`,
    data: [],
    checked: false
  }
  return acc
}, {})
export default {
  name: 'self-lottery-draw',
  mixins: [common],
  components: {
    SelectedTable: () => import('./components/SelectedTable'),
    ActionRecord: () => import('./components/ActionRecord'),
    NumSettedTable: () => import('./components/NumSettedTable')
  },
  data () {
    return {
      showRecord: false,
      filterLength: 0,
      filterData: {}
    }
  },
  computed: {
    ...mapGetters(['getAllGame'])
  },
  watch: {
    getAllGame: {
      immediate: true,
      handler () {
        this.makeData()
      }
    },
    showRecord (val) {
      if (!val) {
        this.$refs.numSetted.search()
      }
    }
  },
  methods: {
    makeData () {
      if (!this.getAllGame.length) return
      let allgame = this.getAllGame.filter((item, index) => (item.ismy == 1 && item.gameGroupId != 11) || item.gameid == 202)
        .map((item, index) => {
          item.checked = false
          return item
        })
      this.filterLength = allgame.length
      let md = {}
      allgame.forEach((item, index) => {
        let sid = item.siteId
        let cid = item.catenaId

        if (sid in md == false) {
          md[sid] = {
            title: `${siteGroup.items[sid]} 全选`,
            data: JSON.parse(JSON.stringify(groupData)),
            checked: false
          }
        }
        let res = md[sid].data
        if (!Object.keys(res).length) {
          this.gameSeries.forEach(it => {
            if (it.id) {
              res[it.id] = {
                title: it.value,
                data: [],
                checked: false
              }
            }
          })
        }
        res[cid].data.push(item)
      })
      this.filterData = md
    },
    goSetting () {
      let allId = []
      this.$refs.selectedTable.forEach(it => {
        allId = allId.concat(it.returnId())
      })
      if (allId.length == 0) {
        this.$Message.error('请选择游戏')
      } else {
        let gameArr = allId.sort((a, b) => a - b).join()
        this.$router.push({ name: 'draw-setting', query: { gid: gameArr } })
      }
    }
  }
}
</script>

<style lang="scss">
.gameSelect .TB_COLLAPSE td {
  padding: 0px;
}
</style>